// Global functions and variables found under _vm.$
import Vue from 'vue'
import store from '../stores/Store.js'
import i18n from '../i18n'
import axios from 'axios'
import moment from 'moment'
import router from '../router/router.js'
import airbrake from '../airbrake.js'

Vue.config.productionTip = false

const handleClientUser = () => {
  let clientUser = window.localStorage.getItem('client_user')
  if (clientUser) {
    window.localStorage.removeItem('client_user')
    window.location.replace(Vue.prototype.$redirectUrl())
  } else {
    router.push('/')
  }
}

// const resetTabletLock = () => {
//   let collectomate_pin_set = window.localStorage.getItem('collectomate_pin_set')
//   if (collectomate_pin_set) {
//     window.localStorage.removeItem('collectomate_pin_set')
//   }
// }

const clearLocalStorage = () => {
  window.localStorage.removeItem('support_session_token')
  window.localStorage.removeItem('delivery_request_token')
  window.localStorage.removeItem('delivery_request_id')
  window.localStorage.removeItem('box_id')
}

Vue.prototype.$success = (message) => {
  store.commit('toast/success', { message })
}

Vue.prototype.$error = (message) => {
  store.commit('toast/error', { message })
}

Vue.prototype.$errorHumanized = (error, customMessage = null) => {
  let response = (error || {}).response || {}
  let statusCode = response.status

  if (statusCode && statusCode == '401') {
    store.commit('toast/error', {
      message: i18n.t('unauthorized')
    })
  } else {
    let errorMessage = (((error || {}).response || {}).data || {}).errors
      ? Object.values(error.response.data.errors).join(', ')
      : customMessage
      ? customMessage
      : i18n.t('error.somethingWentWrong')
    store.commit('toast/error', { message: errorMessage })
  }
}

Vue.prototype.$dev = process.env.VUE_APP_ENV == 'development'
Vue.prototype.$production = process.env.VUE_APP_ENV == 'production'
Vue.prototype.$preprod = process.env.VUE_APP_ENV == 'preprod'

Vue.prototype.$killSession = (options = { performDeliveryResign: true }) => {
  console.log('options', options)
  let deliveryRequestId = window.localStorage.getItem('delivery_request_id')
  if (deliveryRequestId && options.performDeliveryResign) {
    axios({
      method: 'put',
      url: `/delivery_requests/${deliveryRequestId}/resign`,
      headers: {
        common: {
          Authorization: `Bearer ${window.localStorage.getItem('delivery_request_token')}`
        }
      }
    }).finally(() => {
      clearLocalStorage()
      store.commit('killSession')
      handleClientUser()
      // resetTabletLock()
    })
  } else {
    clearLocalStorage()
    store.commit('killSession')
    handleClientUser()
    // resetTabletLock()
  }
}
Vue.prototype.$blockUI = () => {
  store.commit('blockUI', true)
}
Vue.prototype.$unblockUI = () => {
  store.commit('blockUI', false)
}
Vue.prototype.$blockUIRemotely = () => {
  store.commit('blockUIRemotely', true)
}
Vue.prototype.$unblockUIRemotely = () => {
  store.commit('blockUIRemotely', false)
}
Vue.prototype.$hasTouchScreen = (() => {
  var hasTouchScreen = false
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator.msMaxTouchPoints > 0
  } else {
    var mQ = window.matchMedia && matchMedia('(pointer:coarse)')
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches
    } else if ('orientation' in window) {
      hasTouchScreen = true // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      var UA = navigator.userAgent
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
    }
  }
  return hasTouchScreen
})()
Vue.prototype.$isTablet = (() => {
  const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    navigator.userAgent.toLowerCase()
  )
  return isTablet
})()
Vue.prototype.$isMobile = (() => {
  return Vue.prototype.$hasTouchScreen && !Vue.prototype.$isTablet
})()
Vue.prototype.$isRemoteClient = (() => {
  // INFO: window.localStorage.getItem('is_remote_client') is placed for dev purposes only
  // return !!window.localStorage.getItem('is_remote_client') || Vue.prototype.$isMobile && !window.localStorage.getItem('device_id')
  return !window.localStorage.getItem('device_id')
})()
Vue.prototype.$isStationaryClient = !Vue.prototype.$isRemoteClient

Vue.prototype.$clickListener = () => {
  store.commit('resetSessionTimer')
}
Vue.prototype.$format = (date, format) => {
  return date ? moment(date).format(format) : '-'
}
Vue.prototype.$slideUp = (amount = 20) => {
  !Vue.prototype.$dev ? store.commit('slideUp', amount) : null
}
Vue.prototype.$slideDown = () => {
  !Vue.prototype.$dev ? store.commit('slideUp', 0) : null
}
Vue.prototype.$baseURL = process.env.VUE_APP_BASE_URL
Vue.prototype.$cronTimeToSeconds = (cronTime) => {
  if (cronTime.includes('s')) {
    return parseInt(cronTime.split('s')[0])
  } else if (cronTime.includes('m')) {
    return parseInt(cronTime.split('m')[0]) * 60
  }
}
Vue.prototype.$redirectUrl = () => {
  if (Vue.prototype.$production) {
    return `https://pwa.collectomate.io/#/delivery`
  } else if (Vue.prototype.$preprod) {
    return `https://pwa.collectomate-preprod.enginearch.com/#/delivery`
  } else if (Vue.prototype.$dev) {
    return 'http://localhost:8081/#/delivery'
  }
}
Vue.prototype.$clearRemoteClientLocalStorage = () => {
  if (Vue.prototype.$isRemoteClient) {
    window.localStorage.removeItem('support_session_token')
    window.localStorage.removeItem('user_token')
    window.localStorage.removeItem('authorization_qr')
    window.localStorage.removeItem('cp')
    window.localStorage.removeItem('box_id')
    window.localStorage.removeItem('delivery_request_id')
    window.localStorage.removeItem('delivery_request_token')
    window.localStorage.removeItem('client_user')
  }
}
Vue.prototype.$slug = window.location.host.split('.')[0]
Vue.prototype.$isIng = Vue.prototype.$slug == 'ing'
Vue.prototype.$isFrontex = Vue.prototype.$slug == 'frontex'
// Vue.prototype.$isFrontex = true

Vue.prototype.$deviceId = () => {
  return store.getters.getDeviceId
}

Vue.prototype.$airbrake = airbrake
